/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ project: NonNullable<unknown> }} Delete_Ad_Job_TextInputs */



/**
* | output |
* | --- |
* | "Are you sure you want to delete this AD generation job for {project}?" |
*
* @param {Delete_Ad_Job_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const delete_ad_job_text = /** @type {((inputs: Delete_Ad_Job_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delete_Ad_Job_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Êtes-vous sûr de vouloir supprimer cette tâche de génération d'annonces pour ${i?.project} ?`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Möchten Sie diesen AD-Generierungsauftrag für ${i?.project} wirklich löschen?`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Sei sicuro di voler eliminare questo processo di generazione di Active Directory per ${i?.project}?`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Вы уверены, что хотите удалить это задание по генерации AD для ${i?.project}?`)
	if (locale === "es") return /** @type {LocalizedString} */ (`¿Está seguro de que desea eliminar este trabajo de generación de AD para ${i?.project}?`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`您确定要删除 ${i?.project} 的此 AD 生成作业吗？`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.project} の AD 生成ジョブを削除してもよろしいですか？`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`क्या आप वाकई ${i?.project} के लिए इस AD जनरेशन जॉब को डिलीट करना चाहते हैं?`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Tem certeza de que deseja excluir esta tarefa de geração de AD para ${i?.project}?`)
	return /** @type {LocalizedString} */ (`Are you sure you want to delete this AD generation job for ${i?.project}?`)
});